import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import ExchangePairsContainer from "./pairs/ExchangePairsContainer";
import ExchangeUserPairsContainer from "./userPairs/ExchangeUserPairsContainer";
import ExchangeHistoryContainer from "./history/ExchangeHistoryContainer";
import ExchangeProfitContainer from "./profit/ExchangeProfitContainer";

import { StyledExchangeWrapper } from "../styledExchange";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";

const DEFAULT_TAB = "exchange-pairs";

const ExchangeTabsContainer = ({ match }) => {
  const { t } = useTranslation("exchangerPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "exchange-pairs": {
        return 0;
      }
      case "exchange-user-pairs": {
        return 1;
      }
      case "exchange-history": {
        return 2;
      }
      case "exchange-profit": {
        return 3;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper>
      <StyledExchangeWrapper>
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("tabs.pairs")} value="exchange-pairs"/>
            <Tab label={t("tabs.userPairs")} value="exchange-user-pairs"/>
            <Tab label={t("tabs.history")} value="exchange-history" />
            <Tab label={t("tabs.profit")} value="exchange-profit" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <ExchangePairsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <ExchangeUserPairsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={2}
          >
            <ExchangeHistoryContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={3}
          >
            <ExchangeProfitContainer match={match} />
          </TabPanel>
        </StyledTabsBody>
      </StyledExchangeWrapper>
    </StyledContentWrapper>
  );
};

export default ExchangeTabsContainer;